import { motion } from 'framer-motion';
import './TicTacToeBoard.css';

const TicTacToeBoard = ({ board, onCellClick, winningCombination, disabled }) => {
  // Safety check for board
  if (!board || !Array.isArray(board)) {
    console.error('TicTacToeBoard: Invalid board provided:', board);
    return (
      <div className="tictactoe-board">
        <div style={{ color: 'white', padding: '2rem' }}>
          Loading board...
        </div>
      </div>
    );
  }

  const isWinningCell = (index) => {
    return winningCombination && winningCombination.includes(index);
  };

  return (
    <div className="tictactoe-board">
      {board.map((cell, index) => {
        const isEmpty = !cell || cell === '' || cell === null;
        return (
          <motion.button
          key={index}
          className={`tictactoe-cell ${!isEmpty ? 'filled' : ''} ${
            isWinningCell(index) ? 'winning' : ''
          }`}
          onClick={() => onCellClick(index)}
          disabled={disabled || !isEmpty}
          whileHover={{ scale: isEmpty && !disabled ? 1.05 : 1 }}
          whileTap={{ scale: isEmpty && !disabled ? 0.95 : 1 }}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: index * 0.05 }}
        >
          {!isEmpty && (
            <motion.span
              className={`symbol symbol-${cell.toLowerCase()}`}
              initial={{ scale: 0, rotate: -180 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{
                type: 'spring',
                stiffness: 200,
                damping: 15,
              }}
            >
              {cell}
            </motion.span>
          )}
          </motion.button>
        );
      })}
    </div>
  );
};

export default TicTacToeBoard;
